import { z } from 'zod';
import { mongoObjectIdString } from './object-id-helpers.js';

export const ThreatSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    _id: z.string().optional(),
    tenantId: z.string().optional(),
    threatName: z.string().min(1, "form.validation.threatNameRequired").max(255, "form.validation.threatNameTooLong"),
    /** Empty string from UI ("no parent group") clears the ref in MongoDB */
    mainThreatGroup: z.preprocess(
        (v) => {
            if (v === '' || v === null) return null;
            return v;
        },
        z.union([mongoObjectIdString, z.null()]).optional(),
    ),
    description: z.string().min(1, "form.validation.descriptionRequired").max(1000, "form.validation.descriptionTooLong"),
    threatID: z.string().optional(),
    threatValue: z.string().optional(),
    threatStartValue: z.string().optional(),
    threatRules: z.string().optional(),
    parentId: z.union([z.number(), z.string()]).optional().nullable(),
    orderIndex: z.union([z.number(), z.string()]).optional(),
    status: z.enum(["Active", "Inactive"]).optional().default("Active"),
    category: z.string().optional(),
    source: z.string().optional(),
    likelihood: z.string().optional(),
    createdDate: z.union([z.string(), z.date()]).optional(),
    lastUpdated: z.union([z.string(), z.date()]).optional(),
    relatedAssets: z.array(mongoObjectIdString).optional(),
    countermeasures: z.array(mongoObjectIdString).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateThreatSchema = ThreatSchema.omit({ id: true, _id: true, createdDate: true, lastUpdated: true });
export const UpdateThreatSchema = ThreatSchema.partial();

// Frontend Form Schema
export const ThreatFormSchema = ThreatSchema.pick({
    threatName: true,
    mainThreatGroup: true,
    description: true,
    category: true,
    source: true,
    likelihood: true,
    parentId: true,
    orderIndex: true,
    status: true,
    relatedAssets: true,
});
